const colors = {
  transparentLightBeige: "rgba(242,221,200,.5)",
  lightBeige: "#f2ddc8",
  darkBeige: "#c7ab8d",
  lightGreen: "#689276",
  mediumGreen: "rgb(73, 121, 89)",
  darkGreen: "#1B4F2D",
  darkGray:"#323232",
  lightGray: "#8A8A8A",
  darkRed: "#881918",
  lightRed: "rgb(197, 98, 98)"
}

export default colors;